import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "feedback-container" }

import { ref } from "vue";
import FeedbackDialog from "@/components/Modals/FeedbackDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackButton',
  setup(__props) {

const feedbackDialog = ref();

function showFeedbackDialog() {
	feedbackDialog.value.show();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-feedback",
      onClick: showFeedbackDialog
    }, " GIVE FEEDBACK "),
    _createVNode(FeedbackDialog, {
      class: "feedback-dialog",
      ref_key: "feedbackDialog",
      ref: feedbackDialog
    }, null, 512)
  ]))
}
}

})